<template>
  <v-app>
    <v-container>
      <v-card>
        <v-card-title>
          <span class="title">原融/CA 案件快速查詢</span>
        </v-card-title>
        <v-card-text>
          <v-layout mt-2>
            <v-flex md6 xs10>
              <v-text-field
                v-model="search.keyword" :label="`案件查詢`" :placeholder="search.placeholder"></v-text-field>
            </v-flex>
            <v-flex md4 xs4>
              <v-btn color="success" @click="searchEvent">搜尋</v-btn>
              <v-btn color="warning" @click="reset">重置</v-btn>
            </v-flex>
          </v-layout>
          <v-layout v-if="search.loading">
            <v-flex>
              <span class="title">{{ search.message }}</span>
            </v-flex>
          </v-layout>
          <div v-if="getItem">
            <v-layout v-for="(col, i) in columnKeys"
                      :key="`${col.key}_${i}`">
              <v-flex xs6>
                <span class="subheading">{{ col.text }}</span>
              </v-flex>
              <v-flex xs6>
                <div v-if="col.key !=='' && col.subKey === ''">
                  <span class="content" style="color: #00897b; font-weight:bold;" v-if="col.key === 'caseStatus'">{{ getCaseStatus(getItem) }}</span>
                  <span class="content" v-else-if="col.key === 'applyDate'">{{ `${getItem[col.key].year}-${getItem[col.key].month}-${getItem[col.key].day}` }}</span>
                  <span class="content" v-else-if="col.key !=='' && col.subKey === ''">{{ getItem[col.key] }}</span>
                </div>
                <span class="content"
                      v-else-if="col.key !=='' && col.subKey === 'home' && col.thirdKey !== ''">{{ getItem[col.key][col.subKey][col.thirdKey] }}</span>
                <span class="content" v-else-if="col.key !=='' && col.subKey === 'productName'">{{
                    getCaseProduct(getItem)
                  }}</span>

                <span class="content" v-else>{{ getItem[col.key][col.subKey] }}</span>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { searchFinanceInfo } from '../../store/actions';
import common from '../../mixins/common';

export default {
  name: 'SearchFinanceInfo',
  data() {
    return {
      editedItem: null,
      search: {
        loading: false,
        keyword: '',
        placeholder: '搜尋案件編號、身分證、姓名',
        message: '',
      }
    };
  },
  mixins: [common],
  computed: {
    ...mapGetters(['getUserInfo']),
    columnKeys() {
      return [
        { key: 'displayId', subKey: '', text: '案件編號' },
        { key: 'caseStatus', subKey: '', text: '案件狀態' },
        { key: 'applyDate', subKey: '', text: '申請日期' },

        { key: 'vendor', subKey: 'productName', text: '案件類型' },
        { key: 'vendor', subKey: 'totalPrice', text: '申貸金額' },
        { key: 'vendor', subKey: 'installmentsNumber', text: '期數' },
        { key: 'vendor', subKey: 'creditPriceMonth', text: '每期應繳金額' },
        { key: 'vendor', subKey: 'totalCreditPrice', text: '分期總額' },

        { key: 'customer', subKey: 'name', text: '姓名' },
        { key: 'customer', subKey: 'memberId', text: '身分證' },
        { key: 'customer', subKey: 'birthday', text: '出生日期' },
        { key: 'customer', subKey: 'phone', text: '戶籍電話' },
        { key: 'customer', subKey: 'homePhone', text: '住宅電話' },
        { key: 'customer', subKey: 'cellphone', text: '行動電話' },
        { key: 'customer', subKey: 'home', thirdKey: 'residencePost', text: '戶籍地郵遞區號' },
        { key: 'customer', subKey: 'home', thirdKey: 'residenceCity', text: '戶籍縣市' },
        { key: 'customer', subKey: 'home', thirdKey: 'residenceArea', text: '戶籍區' },
        { key: 'customer', subKey: 'home', thirdKey: 'residenceAddress', text: '戶籍地址' },

        { key: 'customer', subKey: 'home', thirdKey: 'homePost', text: '現居郵遞區號' },
        { key: 'customer', subKey: 'home', thirdKey: 'homeCity', text: '現居縣市' },
        { key: 'customer', subKey: 'home', thirdKey: 'homeArea', text: '現居區' },
        { key: 'customer', subKey: 'home', thirdKey: 'homeAddress1', text: '住宅地址' },
        { key: 'customer', subKey: 'home', thirdKey: 'liveYear', text: '居住年' },
        { key: 'customer', subKey: 'home', thirdKey: 'liveMonth', text: '居住月' },
        { key: 'customer', subKey: 'email', text: 'Email' },

        { key: 'company', subKey: 'name', text: '公司名稱' },
        { key: 'company', subKey: 'phone', text: '公司電話' },
        { key: 'company', subKey: 'address', text: '公司地址' },
        { key: 'company', subKey: 'title', text: '職稱' },
        { key: 'company', subKey: 'workYear', text: '年資(年)' },
        { key: 'company', subKey: 'workMonth', text: '年資(月)' },
        { key: 'company', subKey: 'salary', text: '月薪' },

        { key: 'bank', subKey: 'name', text: '發卡銀行' },
        { key: 'bank', subKey: 'effectiveYear', text: '有效日期(年)' },
        { key: 'bank', subKey: 'effectiveMonth', text: '有效日期(月)' },
        { key: 'bank', subKey: 'creditCard', text: '卡號' },

        { key: 'firstContact', subKey: 'name', text: '聯絡人1-姓名' },
        { key: 'firstContact', subKey: 'type', text: '聯絡人1-關係' },
        { key: 'firstContact', subKey: 'cellphone', text: '聯絡人1-行動電話' },
        { key: 'firstContact', subKey: 'homePhone', text: '聯絡人1-住宅電話' },
        { key: 'firstContact', subKey: 'companyPhone', text: '聯絡人1-公司電話' },

        { key: 'secondContact', subKey: 'name', text: '聯絡人2-姓名' },
        { key: 'secondContact', subKey: 'type', text: '聯絡人2-關係' },
        { key: 'secondContact', subKey: 'cellphone', text: '聯絡人2-行動電話' },
        { key: 'secondContact', subKey: 'homePhone', text: '聯絡人2-住宅電話' },
        { key: 'secondContact', subKey: 'companyPhone', text: '聯絡人2-公司電話' },

        //保證人
        { key: 'jointGuarantor', subKey: 'name', text: '保證人姓名' },
        { key: 'jointGuarantor', subKey: 'memberId', text: '保證人身份證字號' },
        { key: 'jointGuarantor', subKey: 'birthday', text: '保證人生日' },
        { key: 'jointGuarantor', subKey: 'cellphone', text: '保證人行動電話' },
        { key: 'jointGuarantor', subKey: 'homePhone', text: '保證人住宅電話' },
        { key: 'jointGuarantor', subKey: 'type', text: '保證人關係' },
        { key: 'jointGuarantor', subKey: 'companyName', text: '保證人公司' },
        { key: 'jointGuarantor', subKey: 'companyPhone', text: '保證人公司電話' },
        { key: 'jointGuarantor', subKey: 'title', text: '保證人職稱' },
      ];
    },
    getItem() {
      return this.editedItem;
    }
  },
  methods: {
    ...mapActions(['fetchFinanceCreditList', 'fetchAgentList', 'searchFinanceInfo']),
    getCaseStatus(item) {
      console.log(`find status ${item.caseStatus}`);
      // 0進件中 1婉拒 2待捕
      const list = this.getCaseStatusList;
      return list.find(i => i.key === item.caseStatus).value;
    },
    getCaseProduct(item) {
      if (item.category === 2 && (item.productId === '0' || !item.productId)) {
        return '商品貸原融';
      }
      if (item.productId === '0') {
        return '機車原融';
      }
      if (item.productId === '1') {
        return '借新還舊';
      }
      if (item.productId === '2') {
        return '他行代償';
      }
      return '機車原融';
    },
    async searchEvent() {
      this.search.loading = true;
      if (this.search.keyword === '') {
        this.search.message = '請輸入案件編號或身分證號！';
        return;
      }

      this.search.message = '查詢中...';
      try {
        const res = await this.searchFinanceInfo({ searchValue: this.search.keyword.trim() });
        console.log(JSON.stringify(res.data.data));
        const caseItem = res.data.data;
        if (caseItem) {
          this.search.loading = false;
          this.editedItem = caseItem;
          console.log(`result = ${JSON.stringify(this.editedItem)}`);
        } else {
          this.search.message = '查無資料！';
        }
      } catch (e) {
        this.search.loading = false;
        this.search.message = '查無資料！';
        console.log(e);
      }
    },
    reset() {
      this.search.loading = false;
      this.search.keyword = '';
      this.editedItem = null;
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/SearchFinanceInfo.vue